$(document).on('turbolinks:load', function () {
  if ($('body').is('[data-js-page-id="static_page#request_box"]')) {
    console.log('static_page#request_box page setup');
    ContactForm.init();
  }
});
